import { cx } from "cva";
import { Body, Headline } from "~/ui-library";
import { ButtonLink } from "~/ui-library/components/ButtonLink/ButtonLink";

export type SubscriptionTrialInlineWarningProps = {
  className?: string;
};

export const SubscriptionTrialInlineWarning: React.FC<
  SubscriptionTrialInlineWarningProps
> = ({ className }) => (
  <div
    className={cx("rounded-3 border-1 border-l-4 border-danger p-m", className)}
  >
    <Headline className="mb-m" level={4}>
      You can&apos;t sign up for another free trial
    </Headline>
    <Body className="mb-m">
      Your account has already started or completed a free trial. Please select
      a subscription plan to continue checking out.
    </Body>

    <div className="flex flex-wrap gap-xs">
      <ButtonLink href="/" variant="subtle">
        Cancel checkout
      </ButtonLink>
      <ButtonLink href="/subscribe#pricing">
        Select a subscription plan
      </ButtonLink>
    </div>
  </div>
);
